var elementsForm,contLogin = 1;
//validacion de cada elemento del formulario y contLogin para validar si hay algun input vacio.

function validationForm(elementsForm,contLogin)
{
    //funcion creada para validar inputs de fomrularios
    for(var i=0;i<elementsForm.length;i++){
        if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
            contLogin = 0;
        }
    }
    return contLogin;
}

$('.btnFormContacto').click(function () {
    //$('#formContacto').submit();
    grecaptcha.ready(function() {
        grecaptcha.execute('6LeaIIkkAAAAALppbcYBsDBy5YsYI50NwTn5NF0o', {action: 'submit'}).then(function(token) {
            $('#formContacto').prepend('<input type="hidden" name="token" value="' + token + '">');
            $('#formContacto').submit();
        });
    });
});


$('#formContacto').on('submit',function (e) {
    e.preventDefault();
    elementsForm = [
        "nameContact",
        "cellphoneContact",
        "emailContact",
        "cityContact",
        "messagueContact",
    ];
    contLogin = validationForm(elementsForm,contLogin = 1);
    if(contLogin == 0)
    {
        swal({
            text: "Debes digitar todos los datos requeridos",
            icon: 'warning',
            button: "OK",
        });
        return false;
    }
    var data = $(this).serialize();
    swal({
        text: "Espere un momento",
        icon: false,
        button: false,
        closeOnClickOutside: false,
    });
    $.ajax({
        url: "/contact",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                $("#formContacto")[0].reset();
                swal({
                    text: "Gracias por contactarnos",
                    icon: "success",
                    button: "OK",
                });
                location.href = '/gracias';
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: "warning",
                    button: "OK!",
                });
            }
        }
    });
});